import { render, staticRenderFns } from "./MultipleCoupons.vue?vue&type=template&id=4c123086"
import script from "./MultipleCoupons.vue?vue&type=script&lang=js"
export * from "./MultipleCoupons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports